<zwi-main-wrapper>
  <zwi-main-content>
    <div class="zwi-section">
      <zwi-back-headline (navigateBack)="navigateToSettings()">Password</zwi-back-headline>
      <zwi-password-form></zwi-password-form>
    </div>
  </zwi-main-content>
</zwi-main-wrapper>
